import initHorizontalSlider from '../components/horizontal-slider';
import initCountProduct from '../utils/customInputNumber';
import initColorPicker from '../components/colorPicker';

var __GLOBAL = {

	/**
	 * Objet de toutes les fonctions initialisation
	 */
	initialize: {

		quickAdd: null,

		/**
		 * Initialise le spinner (input type number)
		 * @param {node} element Objet (node) de l'input à initialiser
		 * @param {bool|function} onStop Fonction appelée aux cliques (+/-), false pour ne pas ajouter d'evenement
		 * @return {void}
		 */
		rangeNumber: function (element, onStop) {
			var $element = $(element);
			var $parent;

			if (!$element) {
				return;
			}
			$parent = $(element.parentNode);
			jcf.replace(element, 'Number');

			if (typeof onStop === 'function') {

				function _onStop() {
					onStop(element);

				}
				$parent.find('.jcf-btn-inc').on('click', _onStop);
				$parent.find('.jcf-btn-dec').on('click', _onStop);
			}
		}

	},

	/**
	 * Objet du minicart - gére le raffraichissement du minicart
	 */
	minicart: {

		className: 'cart-tool__drop',

		elements: null,

		update: function (content) {
      var elements = this.elements;
			var i = 0;

			if (typeof content !== 'string' || elements === null) {
				return false;
			}

      for (i; i < elements.length; i++) {
        elements[i].innerHTML = content;
      }
		},

		initialize: function () {
			var elements = DOC.getElementsByClassName(__GLOBAL.minicart.className);
			var i = 0;
      var element;

			if (typeof elements !== 'object' || elements == null || !elements.length) {
				return __GLOBAL;
			}
			__GLOBAL.minicart.elements = [];

			for (i; i < elements.length; i++) {
				element = elements[i];
				__GLOBAL.minicart.elements[__GLOBAL.minicart.elements.length] = element;
      }
			return __GLOBAL;

		}

	},

	/**
	 * Objet print - gére l'impression d'une page
	 */
	print: {

		className: 'page-print-ev',

		elements: null,

		onClick: function (e) {
			e.preventDefault();
			window.print();

		},

		initialize: function () {
			var elements = DOC.getElementsByClassName(this.className);
			var i = 0;
			var element;

			if (typeof elements !== 'object' || elements == null || !elements.length) {
				return __GLOBAL;
			}
			this.elements = [];

			for (i; i < elements.length; i++) {
				element = elements[i];
				element.addEventListener('click', this.onClick);

				this.elements[this.elements.length] = element;
			}
			return __GLOBAL;

		}

	},

	/**
	 * Objet d'un produit - gére le raffraichissement des options et informations du produit
	 * @TODO
	 */
	product: {

		initialize: function (form) {

		}

	},

	/**
	 * Construit un objet de données d'un formulaire
	 * @param {node} form	Objet (node) du formulaire
	 * @return {object}	Objet des données récupérées
	 */
	getData: function (form) {
		var element, ex, q, id, fld;
		var elements = form.elements;
		var i = 0;
		var data = {};

		if (typeof elements !== 'object' || elements == null || !elements.length) {
			return data;
		}
		for (i; i < elements.length; i++) {
			element = elements[i];

			if (element.name == '') {
				continue;
			}
			ex = element.name.split('[');

			if (ex.length < 2) {
				continue;
			}
			q = ex[0];
			id = ex[1].replace(']', '');

			if (typeof data[q] !== 'object') {
				data[q] = {};
			}

			if (ex.length === 3) {
				fld = ex[2].replace(']', '');

				if (typeof data[q][id] !== 'object') {
					data[q][id] = {};

				}
				data[q][id][fld] = element.value;
				continue;
			}
			data[q][id] = element.value;
		}
		return data;

	},

	/**
	 * Retourne l'HTML du bloc message
	 * @param {string} type Type du message (error, success, warning)
	 * @param {string} txt Texte du message
	 * @return {string} HTML du bloc message, chaine de caratère vide en cas d'erreur
	 */
	message: function (type, txt) {
		var className;

		if (typeof txt !== 'string') {
			return '';
		}

		switch (type) {
			case 'error':
			case 'ERROR':
				className = 'error';
				break;
			case 'success':
			case 'SUCCESS':
				className = 'success';
				break;
			case 'warning':
			case 'WARNING':
				className = warning;
			default:
				return '';
		}
		return '<div class="' + className + '">' + txt + '</div>';

	},

	/**
	 * HTML de chargement (principalement utilisé pour l'ajax)
	 * @return {string} HTML du logo de chargement
	 */
	loading: function () {
		return '<div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';

	},
};

const DOC = document;

const productActions = ( body, form ) => {
  var CORE = {

    popup: {

      classNames: {
        opened: 'popup-atc-opened'
      },

      isOpened: false,

      element: null,

      close: {

        className: 'popup-atc__close',

        elements: null,

        onClose: function (e) {
          var self = CORE.popup;
          e.preventDefault();

          if (!self.isOpened) {
            return;
          }

          if (self.element.parentNode !== null) {
            self.element.parentNode.removeChild(self.element);
          }
          body.removeClass(self.classNames.opened);
          self.isOpened = false;

        },

        construct: function () {
          var self = CORE.popup;
          var close = DOC.getElementsByClassName(self.close.className);
          var i = 0;

          if (typeof close !== 'object' || close == null || !close.length) {
            return;
          }
          self.elements = [];

          for (i; i < close.length; i++) {
            self.elements[self.elements.length] = close[i];
            close[i].addEventListener('click', self.close.onClose);

          }

        }

      },

      initialize: function (content) {
        var self = CORE.popup;

        if (self.isOpened || typeof content !== 'string') {
          return;
        }

        if (self.element === null) {
          self.construct();
        }
        self.element.firstChild.firstChild.innerHTML = content;
        DOC.body.appendChild(self.element);
        body.addClass(self.classNames.opened);
        self.isOpened = true;
        self.close.construct();

      },

      construct: function () {
        CORE.popup.element = DOC.createElement('div');

        CORE.popup.element.id = 'popup-atc';
        CORE.popup.element.className = 'popup-atc popup-atc--holder';
        CORE.popup.element.innerHTML = '<div class="popup-atc__inner"><div class="popup-atc__content popup popup--cart fancybox-content"></div></div>';

      }

    },

    message: {

      className: 'response-holder',

      elements: null,

      reset: function () {
        CORE.message.content('');

      },

      content: function (content) {
        var elements = CORE.message.elements;
        var i = 0;

        if (typeof content !== 'string') {
          return;
        }

        if (typeof elements !== 'object' || elements == null || !elements.length) {
          return;
        }

        for (i; i < elements.length; i++) {
          elements[i].innerHTML = content;

        }

      },

      construct: function () {
        var elements = form.getElementsByClassName(this.className);
        var i = 0;

        if (typeof elements !== 'object' || elements == null || !elements.length) {
          return;
        }
        this.elements = [];

        for (i; i < elements.length; i++) {
          this.elements[this.elements.length] = elements[i];

        }

      }

    },

    submit: {

      className: 'product-form__add',

      elements: null,

      onSubmit: function (e, isParent) {
        $('.rf-ajax-load').show();
        e.preventDefault();

        var data = __GLOBAL.getData(form);

        // S'il s'ajout d'un produit parent, la popup sera celle permettant d'ajout un article enfant
        if( isParent ){
          $.ajax({
            method: 'GET',
            url: '/ajax/popup-add-by-parent.php',
            data: {
              product: data
            }
          }).done( function(response) {
            response = $.parseJSON(response);

            if (typeof response !== 'object' || !('content' in response) || !('state' in response) || typeof response.content !== 'object') {
              $('.rf-ajax-load').hide();
              CORE.message.content(__GLOBAL.message('error', 'Le produit n\'a pas été ajouté au panier.'));
              return;
            }

            if (response.state == 1) {
              if ('popup' in response.content && typeof response.content.popup === 'string') {
                CORE.popup.initialize(response.content.popup);
                initHorizontalSlider();
                initCountProduct();
                initColorPicker();

                { // Charge l'action d'ajout au panier dans la popup pour chaque article enfant
                  var product = DOC.getElementsByClassName( 'product-form' );
                  var i = 0;

                  if (typeof product !== 'object' || product == null || !product.length) {
                  }else{
                    this.product = [];

                    for (i; i < product.length; i++) {
                      this.product[this.product.length] = product[i];

                      if( !$( product[i] ).hasClass('__init') ){
                        $( product[i] ).addClass('__init');
                        productActions($('body'), product[i]);
                      }
                    }
                  }
                }
              }

              $('.rf-ajax-load').hide();
              return;
            }

            $('.rf-ajax-load').hide();
            CORE.message.content(__GLOBAL.message('error', response.content));
          });

          return;
        }

        // Ajout d'un produit standard ou enfant depuis la popup du parent
        $.ajax({

          method: 'POST',
          url: '/ajax/popup-add-to-cart.php',
          data: {
            ajax: 'cart',
            isNomenclature: CORE.nomenclatures.elements !== null,
            product: data,
          }

        }).done(function (response) {
          response = $.parseJSON(response);

          if (typeof response !== 'object' || !('content' in response) || !('state' in response) || typeof response.content !== 'object') {
            $('.rf-ajax-load').hide();
            CORE.message.content(__GLOBAL.message('error', 'Le produit n\'a pas été ajouté au panier.'));
            return;
          }

          if (response.state == 1) {
            CORE.message.reset();

            if ('popup' in response.content && typeof response.content.popup === 'string') {
              CORE.popup.initialize(response.content.popup);
            }

            if ('minicart' in response.content && typeof response.content.minicart === 'string') {
              __GLOBAL.minicart.update(response.content.minicart);
            }

            $('.rf-ajax-load').hide();
            return;
          }

          $('.rf-ajax-load').hide();
          CORE.message.content(__GLOBAL.message('error', response.content));
        });

      },

      construct: function () {
        var elements = form.getElementsByClassName(this.className);
        var i = 0;

        if (typeof elements !== 'object' || elements == null || !elements.length) {
          return;
        }
        this.elements = [];

        for (i; i < elements.length; i++) {
          this.elements[this.elements.length] = elements[i];

          elements[i].addEventListener('click', function (e) {
            e.preventDefault();

            var isParent = false;
            if( $(this).parents('form').find('[name="is_parent"]').val() == 'yes' ){
              isParent = true;
            }

            CORE.submit.onSubmit( e, isParent );
          });

        }

      }

    },

    images: {

      className: 'prd-img-prw',

      elements: null,

      targetIndex: function (prd) {
        var elements = CORE.images.elements;
        var i = 0;
        var element;

        prd = parseInt(prd);

        if (typeof prd !== 'number' || prd < 1 || elements === null || !elements.length) {
          return false;
        }

        for (i; i < elements.length; i++){
          element = elements[i];

          if (!('dataset' in element) || typeof element.dataset !== 'object') {
            continue;
          }

          if (!('prd' in element.dataset) || !('slickIndex' in element.dataset) ) {
            continue;
          }

          if (prd == parseInt(element.dataset.prd)) {
            $('.product-img-slider-preview').slick('slickGoTo', element.dataset.slickIndex);
            return;
          }

        }
        return false;

      },

      construct: function () {
        var elements = DOC.getElementsByClassName(this.className);
        var i = 0;

        if (typeof elements !== 'object' || elements == null || !elements.length) {
          return;
        }
        this.elements = [];

        for (i; i < elements.length; i++) {
          this.elements[this.elements.length] = elements[i];

        }

      }

    },

    options: {

      classNames: {
        target: 'prd-opt-targeted',
        error: 'prd-opt-error'
      },

      elements: null,

      selected: null,

      verify: function () {
        var elements = CORE.options.elements;
        var i = 0;
        var pass = true;
        var element, $element;

        if (typeof elements !== 'object' || elements == null || !elements.length) {
          return false;
        }

        for (i; i < elements.length; i++) {
          element = elements[i];
          $element = $(element);
          $element.removeClass(CORE.options.classNames.error);

          if (elements[i].value == '') {
            pass = false;
            $element.addClass(CORE.options.classNames.error);

          }

        }
        return pass;

      },

      getFldID: function (name) {
        var start = name.lastIndexOf('[');
        var stop = name.lastIndexOf(']');

        return parseInt(name.substring(start + 1, stop));

      },

      onSelect: function (e, el) {
        var data = {
          ajax: 'options'

        };
        var i, gdata;

        if (!CORE.options.verify()) {
          return;
        }
        gdata = __GLOBAL.getData(form);

        if (typeof gdata != 'object' || !('main-prd' in gdata) || !('opt-fld' in gdata)) {
          return;
        }

        for (i in gdata['opt-fld']) {
          data['opt-fld'] = gdata['opt-fld'][i];
          break;
        }

        for (i in gdata['main-prd']) {
          data['prd'] = gdata['main-prd'][i];
          break;
        }

        data['fld-id'] = this.getFldID(el.name);

        $.ajax({
          method: 'GET',
          url: '/ajax/product.php',
          data: data

        }).done(function (response) {
          response = $.parseJSON(response);

          CORE.message.reset();
          CORE.parts.resetAll();

          if (typeof response !== 'object' || !('content' in response) || !('state' in response) || !('product' in response)) {
            CORE.message.content(__GLOBAL.message('error', 'Une erreur est survenue. Veuillez réessayer.'));
            initStickyScrollBlock();
            return;
          }

          if (response.state == 1 && typeof response.content === 'object') {
            CORE.parts.set('price', response.content.price);
            CORE.parts.set('stock', response.content.stock);
            CORE.parts.set('delivery', response.content.delivery);
            CORE.parts.set('spinner', response.content.spinner);
            initStickyScrollBlock();
            if ('product' in response && typeof response.product === 'object' && 'id' in response.product) {
              CORE.images.targetIndex(response.product.id);
            }
            return;
          }

          if (typeof response.content !== 'string') {
            CORE.message.content(__GLOBAL.message('error', 'Une erreur est survenue. Veuillez réessayer.'));
            initStickyScrollBlock();
            return;
          }
          CORE.message.content(__GLOBAL.message('error', response.content));
          initStickyScrollBlock();

        });

      },

      construct: function () {
        var elements = form.getElementsByClassName(this.classNames.target);
        var i = 0;

        if (typeof elements !== 'object' || elements == null || !elements.length) {
          return;
        }

        if (this.elements !== 'object') {
          this.elements = [];
        }

        for (i; i < elements.length; i++) {
          this.elements[this.elements.length] = elements[i];
          elements[i].addEventListener('change', function (e) {
            e.preventDefault();
            CORE.options.onSelect(e, this);
          });

          jcf.replace(elements[i], 'Select', {
            wrapNative: false,
            wrapNativeOnMobile: false,
            flipDropToFit: false,
            fakeDropInBody: false
          });

        }

      }

    },

    nomenclatures: {

      /**
       * @var	{object}	classNames Objet contenant les noms des classes
       */
      classNames: {
        target: 'prd-nom-targeted',
        error: 'prd-nom-error'
      },

      /**
       * @var {object} elements Objet contenant tous les noeuds (nodes) des nomenclatures
       */
      elements: null,

      /**	Cette fonction permet de vérifier le formulaire des nomenclatures
       *
       * @param {object} data Objet contenant les informations récupérées du formulaire
       * @return {bool|object} Objet contenant les informations du formulaire, false en cas d'erreur
       */
      verify: function (data) {
        var elements = CORE.nomenclatures.elements;
        var i = 0;
        var pass = true;
        var gdata = {};
        var element, $element, a, name;

        if (typeof data != 'object' || !('main-prd' in data)) {
          return false;
        }

        if (typeof elements !== 'object' || elements == null || !elements.length) {
          return false;
        }

        for (a in data['main-prd']) {
          gdata['prd'] = data['main-prd'][a];
          break;
        }

        for (i; i < elements.length; i++) {
          element = elements[i];
          $element = $(element);
          $element.removeClass(CORE.nomenclatures.classNames.error);

          if (element.value == '') {
            pass = false;
            $element.addClass(CORE.nomenclatures.classNames.error);
            continue;
          }
          name = CORE.nomenclatures.getName(element.name);

          if (!(name in data)) {
            pass = false;
          }

          for (a in data[name]) {
            if (data[name][a] != element.value) {
              pass = false;
            }
            gdata[name] = element.value;
            break;
          }

        }
        return pass ? gdata : false;

      },

      /**	Cette fonction permet d'extraire le nom de la nomenclature
       *
       * @param {string} name Nom du noeud (node) brut
       * @return {string} Nom de la nomenclature
       */
      getName: function (name) {
        var stop = name.indexOf('[');

        return name.substring(0, stop);

      },

      /** Cette fonction est un événement déclenché à chaque changement d'un noeud nomenclature
       *
       * @param {object} e Objet de l'événement
       * @return void
       */
      onSelect: function (e) {

        e.preventDefault();

        CORE.nomenclatures.verify(__GLOBAL.getData(form));

      },

      /**	Cette fonction doit être appelée une fois et sert à initialiser le module nomenclature
       *
       * @return void
       */
      construct: function () {
        var elements = form.getElementsByClassName(this.classNames.target);
        var i = 0;

        if (typeof elements !== 'object' || elements == null || !elements.length) {
          return;
        }

        if (this.elements !== 'object') {
          this.elements = [];
        }

        for (i; i < elements.length; i++) {
          this.elements[this.elements.length] = elements[i];
          elements[i].addEventListener('change', this.onSelect);

          jcf.replace(elements[i], 'Select', {
            wrapNative: false,
            wrapNativeOnMobile: false,
            flipDropToFit: false,
            fakeDropInBody: false
          });

        }

      }

    },

    parts: {

      elements: {
        spinner: {
          className: 'product-spinner--holder',
          elements: null,
          after: function (el) {
            var els = el.getElementsByClassName('spinner');
            var i = 0;

            if (!els || els == null || typeof els !== 'object' || !('length' in els)) {
              return false;
            }

            for (i; i < els.length; i++) {
              __GLOBAL.initialize.rangeNumber(els[i]);
            }
          }
        },
        price: {
          className: 'product-price--holder',
          elements: null
        },
        stock: {
          className: 'product-availability--holder',
          elements: null
        },
        delivery: {
          className: 'product-dnd--holder',
          elements: null
        }
      },

      isset: function (key) {

        if (typeof CORE.parts.elements !== 'object' || typeof key !== 'string') {
          return false;
        }

        if (!(key in CORE.parts.elements) || typeof CORE.parts.elements[key] !== 'object') {
          return false;

        }

        return ('elements' in CORE.parts.elements[key]);

      },

      set: function (key, content) {
        var obj, elements, element;
        var i = 0;

        if (!CORE.parts.isset(key) || typeof content !== 'string') {
          return false;
        }
        obj = CORE.parts.elements[key];
        elements = obj.elements;

        if (!elements.length) {
          return false;
        }

        for (i; i < elements.length; i++) {
          element = elements[i];
          element.innerHTML = content;

          if ('after' in obj && typeof obj.after === 'function') {
            obj.after(element);
          }
        }
        return true;

      },

      reset: function (key) {

        return CORE.parts.set(key, '');

      },

      resetAll: function () {
        var elements = CORE.parts.elements;
        var error = 0;
        var i;

        if (typeof elements !== 'object') {
          return false;
        }

        for (i in elements) {
          if (!CORE.parts.reset(i)) {
            error++;
          }
        }
        return error === 0;

      },

      construct: function () {
        var parts = this.elements;
        var i, a, els;

        for (i in parts) {

          if (!this.isset(i)) {
            continue;
          }
          els = form.getElementsByClassName(parts[i].className);

          if (!els || els === null || typeof els !== 'object' || !('length' in els)) {
            continue;
          }
          parts[i].elements = [];

          for (a = 0; a < els.length; a++) {
            parts[i].elements[parts[i].elements.length] = els[a];

          }

        }


      }

    },

    construct: function () {
      this.submit.construct();
    }

  };

  CORE.construct();
};

export default { Minicart: __GLOBAL.minicart.initialize, Product: productActions };
